/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function Swap(props) {
  const { size, color, ...other } = props;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      height={size}
      width={size}
      title="swap-ico"
      {...other}
    >
      <path
        d="M3 8.27273L6.27273 5L9.54545 8.27273"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1818 19.7273H9.54544C8.67746 19.7273 7.84503 19.3825 7.23128 18.7687C6.61752 18.155 6.27272 17.3225 6.27272 16.4546L6.27272 5.00002"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 16.4546L17.7273 19.7273L14.4546 16.4546"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8182 5.00002H14.4546C15.3226 5.00002 16.155 5.34483 16.7687 5.95858C17.3825 6.57234 17.7273 7.40477 17.7273 8.27275V19.7273"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Swap.defaultProps = {
  color: "currentColor",
  size: 24,
};

Swap.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
